module.exports = __webpack_public_path__ + "img/thumbnail_HamadryasBaboon_f_normal.90585d1b.png";